const wrap = (el: HTMLElement, wrapper: HTMLElement) => {
    const parentElement = el.parentNode as HTMLElement
    if (parentElement) {
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
    }
}

export default wrap
